import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const CartContext = createContext();

export const useCartContext = () => useContext(CartContext);
const getCookieValue = (cookieName) => {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((c) => c.startsWith(`${cookieName}=`));
    return cookie ? cookie.split('=')[1] : null;
};
export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);



    const fetchCartItemsLogued = async () => {
        console.log("Obteniendo carrito logueado...");
        try {
            const response = await axios.get("/cart/", {
                withCredentials: true
            });
            console.log("Carrito obtenido LOGUEADO:", response.data);
            setCartItems(response.data.items || []);
        } catch (err) {
            console.error("Error al obtener productos del carrito:", err);
            // setError("No se pudieron cargar los productos del carrito.");
        } finally {
            // setLoading(false);
        }
    };
    const fetchCart = async () => {
        try {
            const response = await axios.get("/cart/", { withCredentials: true });
            setCartItems(response.data?.items ?? []);
        } catch (error) {
            if (error.response?.status === 404) {
                createAnonymousCart();
            } else {
                console.error("Error al obtener el carrito:", error);
            }
        }
    };


    const createAnonymousCart = async () => {
        console.log("Creando carrito anónimo...");
        try {
            const response = await axios.post("/cart/anonymous/", null, {
                withCredentials: true
            });


        } catch (err) {
            console.error("Error al crear carrito anónimo:", err);
        }
    };
    // Al montar el componente, revisa si el usuario ya tiene un carrito anónimo
    // y en caso de no tenerlo, pide uno al servidor
    useEffect(() => {

        // console.log("1111111111111")
        fetchCart();
    }, []);

    const toastStyle = {
        background: 'oklch(var(--b2))',
        color: 'oklch(var(--bc))',
        borderLeft: '3px solid #ef4444',
        fontSize: '0.875rem',
        boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
    };

    // Agregar producto al carrito
    const addToCart = async (product) => {
        try {
            await axios.post("/cart/items/", {
                product_id: product?.id,
                quantity: 1
            });
            // Re-fetch to always get the real cart state regardless of POST response format
            const cartResponse = await axios.get("/cart/", { withCredentials: true });
            setCartItems(cartResponse.data?.items ?? []);
            toast.success(
                `"${product?.name}" añadido al carrito`,
                {
                    position: "bottom-right",
                    autoClose: 2500,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    style: toastStyle,
                }
            );
        } catch (error) {
            const status  = error?.response?.status;
            const detail  = error?.response?.data
                ? JSON.stringify(error.response.data)
                : error?.message;
            console.error(`Error al añadir al carrito [${status ?? 'network'}]:`, detail);
            toast.error(
                `Error ${status ?? ''}: ${detail ?? 'No se pudo añadir al carrito'}`,
                {
                    position: "bottom-right",
                    autoClose: 4000,
                    style: { ...toastStyle, borderLeft: '3px solid #f87171' },
                }
            );
        }
    };

    // Añadir un paquete digital propio y aprobado al carrito (MVP-02 §3).
    // A diferencia de addToCart, exige sesión y el backend puede rechazar por
    // ownership/estado (404 ajeno/inexistente, 409 no aprobado/sin licencia).
    const addDigitalToCart = async (packageId) => {
        try {
            const response = await axios.post(
                "/cart/items/digital/",
                { package_id: packageId },
                { withCredentials: true }
            );
            setCartItems(response.data?.items ?? []);
            toast.success("Paquete digital añadido al carrito", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                style: toastStyle,
            });
            return { ok: true };
        } catch (error) {
            const detail = error?.response?.data?.detail || 'No se pudo añadir el paquete digital al carrito.';
            const code = error?.response?.data?.code;
            toast.error(detail, {
                position: "bottom-right",
                autoClose: 4000,
                style: { ...toastStyle, borderLeft: '3px solid #f87171' },
            });
            return { ok: false, detail, code };
        }
    };

    // Actualizar cantidad de un producto en el carrito
    const updateCartItemQuantity = async (itemId, quantity) => {
        try {
            const response = await axios.patch(
                `/cart/items/${itemId}/update/`,
                { quantity }, // Enviar la nueva cantidad
                { withCredentials: true }
            );
            // Actualizar estado local con el carrito actualizado
            setCartItems(response.data.items || []);
            console.log("Carrito actualizado:", response.data);
        } catch (error) {
            console.error("Error al actualizar la cantidad del producto:", error);
        }
    };

    // Eliminar un producto específico del carrito
    const removeFromCart = async (productId) => {
        try {
            // Suponiendo que en tu API se borra con /api/cart/items/<productId>/
            const response = await axios.delete(
                `/cart/items/${productId}/`,
                // { withCredentials: true }
            );
            setCartItems(response.data.items);
        } catch (error) {
            console.error("Error al eliminar producto del carrito:", error);
        }
    };

    // Vaciar el carrito
    const clearCart = async () => {
        try {
            // Un endpoint para vaciar el carrito
            const response = await axios.delete("/api/cart/clear/", {
                withCredentials: true
            });
            setCartItems(response.data.items);
        } catch (error) {
            console.error("Error al vaciar el carrito:", error);
        }
    };

    return (
        <CartContext.Provider
            value={{
                cartItems,
                setCartItems,
                addToCart,
                addDigitalToCart,
                removeFromCart,
                clearCart,
                fetchCartItemsLogued,
                fetchCart,
                updateCartItemQuantity
            }}
        >
            {children}
        </CartContext.Provider>
    );
};
